export default class ConfirmTokenRepository {
  constructor({ confirmTokenService }) {
    this.confirmTokenService = confirmTokenService;
  }

  confirmToken(token) {
    return this.confirmTokenService.confirmToken(token);
  }
}
